var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
//import { useBranchesPatch  } from "../../fnx/branches/branchesPatch";
//import { useBranchesPost  } from "../../fnx/branches/branchesPost";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { useCataloguesGetAll } from "../../fnx/catalogue/catalogueGetAll";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var CataloguesAdmin = function () {
    var dispatch = useDispatch();
    var _a = useState([]), list = _a[0], setList = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(""), typeCatalog = _c[0], setTypeCatalog = _c[1];
    var _d = useState(false), triggerPost = _d[0], setTriggerPost = _d[1];
    var _e = useState(false), triggerPatch = _e[0], setTriggerPatch = _e[1];
    var _f = useState({
        data: { clientId: "" },
    }), bodyRequest = _f[0], setBodyRequest = _f[1];
    var _g = useState(false), openModal = _g[0], setOpenModal = _g[1];
    var _h = useState(false), openModalConfirm = _h[0], setOpenModalConfirm = _h[1];
    var _j = useState(false), openModalCloneConfirm = _j[0], setOpenModalCloneConfirm = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = useState(false), isUpdate = _k[0], setIsUpdate = _k[1];
    var _l = useState(null), itemModal = _l[0], setitemModal = _l[1];
    var _m = useState({
        Id: "",
        Name: "",
    }), dataForm = _m[0], setDataForm = _m[1];
    var _o = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _o[0], setSeeToast = _o[1];
    var _p = useCataloguesGetAll(trigger, "CATALOG_SEXO", clientId), responseCatalogues = _p.responseCatalogues, errorCatalogues = _p.errorCatalogues, loadingCatalogues = _p.loadingCatalogues;
    // const { responsePostBranches, errorPostBranches, loadingPostBranches } = useBranchesPost(triggerPost,bodyRequest);
    //const { responsePatchBranches, errorPatchBranches, loadingPatchBranches }  = useBranchesPatch (triggerPatch,bodyRequest);
    var _q = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _q.responseDeleteEntity, loadingDeleteEntity = _q.loadingDeleteEntity, errorDeleteEntity = _q.errorDeleteEntity;
    var callCatalogues = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callCatalogues();
    }, []);
    useEffect(function () {
        if (responseCatalogues && (responseCatalogues === null || responseCatalogues === void 0 ? void 0 : responseCatalogues.length) > 0) {
            var listCatalogues = responseCatalogues.map(function (item) { return ({
                id: item.id,
                title: item.description,
                code: item.type,
                clientId: item.clientId,
            }); });
            setList(listCatalogues);
        }
    }, [responseCatalogues]);
    //  useEffect(() => {
    //  setTriggerPost(false);
    //if (responsePostBranches && responsePostBranches?.data) {
    // setSeeToast({
    //   show: true,
    //    message: "Creado con éxito",
    //    type: typeAlert.success,
    //  });
    //  setTimeout(() => {
    //    setSeeToast({
    //      show: false,
    //         message: "",
    //         type: typeAlert.success,
    //       });
    //     }, 3000);
    //     setOpenModal(false);
    //   } else if (errorPostBranches) {
    //     setSeeToast({
    //       show: true,
    //       message: errorPostBranches?.message.message,
    //       type: typeAlert.error,
    //     });
    //     setTimeout(() => {
    //       setSeeToast({
    //         show: false,
    //         message: "",
    //         type: typeAlert.error,
    //       });
    //     }, 3000);
    //   }
    // }, [responsePostBranches, errorPostBranches]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    // useEffect(() => {
    //   setTriggerPatch(false);
    //   if (responsePatchBranches && responsePatchBranches.data) {
    //     setSeeToast({
    //       show: true,
    //       message: "Actualizado con éxito",
    //       type: typeAlert.success,
    //     });
    //     setTimeout(() => {
    //       setSeeToast({
    //         show: false,
    //         message: "",
    //         type: typeAlert.success,
    //       });
    //     }, 3000);
    //     setOpenModal(false);
    //     setTrigger(true);
    //     //dispatch(patchSponsorClearData());
    //   } else if (errorPatchBranches) {
    //     setSeeToast({
    //       show: true,
    //       message: errorPatchBranches?.message,
    //       type: typeAlert.error,
    //     });
    //     setTimeout(() => {
    //       setSeeToast({
    //         show: false,
    //         message: "",
    //         type: typeAlert.error,
    //       });
    //     }, 3000);
    //   }
    // }, [responsePatchBranches, errorPatchBranches]);
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { Id: row.id, Name: row.title, clientId: row.clientId }));
    };
    var handleSubmit = function (dataItem) {
        // if (isUpdate) {
        //   let id = dataForm.Id;
        //   setBodyRequest({
        //     data: {
        //       clientId: dataItem.clientId,
        //       name: dataItem.Name,
        //       description
        //
        //     },
        //   });
        //   setTriggerPatch(true);
        // } else {
        //   let body = {
        //     clientId: dataItem.clientId,
        //     name: dataItem.Name,
        //   };
        //   setBodyRequest({
        //     data: {
        //       clientId: clientId,
        //       description: dataItem.Name,
        //       code: dataItem.Name,
        //       maxCharacter: 100,
        //       minCharacter: 10,
        //       isNumeric: true,
        //     },
        //   });
        //   setTriggerPost(true);
        // }
        // setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { Id: "", Name: "", clientId: "", Image: "" }));
    };
    var handleOnClickButtonOptionsDropdown = function (opt, item) {
        if (opt.id === "1") {
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(item);
        }
        else if (opt.id === "2") {
            setitemModal(item);
            setOpenModalConfirm(true);
        }
        else if (opt.id === "3") {
            setitemModal(item);
            setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    var handleDelete = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
        dispatch(deleteEntity({
            id: itemModal.id,
            entity: "BranchEntity",
            idUser: "d2bd577e-c8c6-4519-b30a-b8e674c42952",
        }));
    };
    var handleClone = function () { };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Catalogos Generales", list: list, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onSaveData: handleSubmit, onClickAdd: handleOnClickAdd, onClickButtonOptionsDropdown: function (opt, item) {
                    handleOnClickButtonOptionsDropdown(opt, item);
                } })] }));
};
export default CataloguesAdmin;
